import { ComponentChildren } from 'preact'
import { Segment } from 'semantic-ui-react'
import './index.css'

export const BarcodeMenuOptionsOverlayContainer = ({
  children,
  className,
  ...rest
}: {
  children: ComponentChildren
  className?: string
}) => {
  const _className = [className, 'barcodeOverlay'].join(' ')
  return (
    <Segment inverted {...rest} className={_className}>
      {children}
    </Segment>
  )
}
